export const mutations = {
  addDeadSaleItems(state) {
    state.dead_sale_items.push({
      product_id: "",
      truck_id: "",
      product_measurement: "",
      balance_stock: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remark: ""
    });
  },

  STORE_DEAD_SALES(state, deadsales) {
    state.deadsales = deadsales;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/deadsales/mutations.js